/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {firstValueFrom, tap} from 'rxjs';

import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';
import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {
  NotificationPreferencesApiService,
  NotificationPreferencesModel
} from './notification-preferences-api.service';
import {NotificationPreferencesEditPageComponent} from './notification-preferences-edit-page.component';

export function notificationPreferencesStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  const api = adnRouterHelper.services.service(NotificationPreferencesApiService);
  const userProfileSaver = adnRouterHelper.services.service(UserProfileSaverService);

  states.add('app.adm.notification-preferences', {
    url: '/notification-preferences',
    data: {title: 'notificationPreferences.notificationPreferences'},
    resolve: {
      notificationPreferencesPage: function() {
        return firstValueFrom(api.getCurrent().pipe(
          tap((model) => userProfileSaver.saveObj(model, 'adnLastViewed'))
        )).then((model) => new SignalAdminResourcePageState(
          model,
          false,
          false,
          api,
          'Notification Preferences'
        ));
      },
      model: function(notificationPreferencesPage: SignalAdminResourcePageState<NotificationPreferencesModel>) {
        return notificationPreferencesPage.model();
      }
    },
    views: {
      'content@app': {
        component: NotificationPreferencesEditPageComponent,
        bindings: {state: 'notificationPreferencesPage'}
      },
      'title@app': stateTitleView()
    }
  });
  return states.build();
}
